var _defs, _path, _polygon, _rect, _path2;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNovapointWaterwaySvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "xaml",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#363545;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "NovapointWaterway_svg") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M16,13.15,6.14,14.89a12.52,12.52,0,0,0,3.91,7.74A3.48,3.48,0,0,1,12,22a3.63,3.63,0,0,1,2.26.77,3.57,3.57,0,0,1,1.93-.55,3.68,3.68,0,0,1,1.86.54,3.56,3.56,0,0,1,2.06-.65h.25a3.43,3.43,0,0,1,1.58.49,12.52,12.52,0,0,0,3.91-7.74ZM12,18a1,1,0,1,1,1-1A1,1,0,0,1,12,18Zm8,0a1,1,0,1,1,1-1A1,1,0,0,1,20,18Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "16 11.12 22 12.18 22 9 10 9 10 12.18 16 11.12"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 13,
    y: 3,
    width: 6,
    height: 4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M6,28.09H6c-1,0-1.45-.85-1.8-1.46a5.09,5.09,0,0,0-.3-.5A4.52,4.52,0,0,0,3,27.37l-1.75-1c.59-1.08,1.54-2.49,2.89-2.34,1,.11,1.44,1,1.79,1.57l.09.15.12-.2C6.51,25,7,24.09,8,24.09H8c1,0,1.49.86,1.83,1.42a1.86,1.86,0,0,0,.13.23,1.65,1.65,0,0,0,.15-.25C10.52,24.88,11,24,12,24h0c1,0,1.51.83,1.89,1.44l.24.36c.07-.09.14-.2.19-.28a2.29,2.29,0,0,1,1.87-1.3A2.21,2.21,0,0,1,18,25.55l.12.18.21-.29c.38-.55.93-1.38,1.93-1.31s1.39.88,1.69,1.42c0,.05,0,.1.08.16l.19-.27c.42-.6,1-1.43,2-1.37A2.3,2.3,0,0,1,26,25.46l0,.05a2.59,2.59,0,0,1,1.63-1.39c1.36-.25,2.44,1.05,3.12,2.05l-1.65,1.14A3.6,3.6,0,0,0,28,26.12a3.22,3.22,0,0,0-.31.45A2.08,2.08,0,0,1,26,27.83h0a2.14,2.14,0,0,1-1.75-1.34,3,3,0,0,1-.16-.26l-.26.36a2.38,2.38,0,0,1-2,1.34,2.19,2.19,0,0,1-1.67-1.42s-.05-.09-.07-.14l-.15.21c-.38.55-1,1.39-2,1.33a2.21,2.21,0,0,1-1.72-1.31,1.3,1.3,0,0,0-.1-.15l-.13.2A2.38,2.38,0,0,1,14.19,28h0c-1,0-1.57-.88-1.93-1.46l-.2-.3-.2.31C11.5,27.11,11,28,10,28s-1.49-.87-1.83-1.44L8,26.34c-.06.09-.11.19-.16.26C7.5,27.23,7,28.09,6,28.09Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNovapointWaterwaySvg);
export default __webpack_public_path__ + "static/media/NovapointWaterway_svg.d160bab2f64990e17a139ca90918c292.svg";
export { ForwardRef as ReactComponent };